import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DynamicComponent from './Component/DynamicComponent';
import axios from 'axios';

const Activity = () => {
  const { link, params } = useParams();

  const url = window.location.origin;  
  const parsedUrl = new URL(url);
  const domain = parsedUrl.hostname;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [appLogo, setAppLogo] = useState(`/assets/icon_network.png`);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}api/system/home?domain=${domain}`);
        
        setAppLogo(`${process.env.REACT_APP_API_URL}upload/logo/${response.data.logo}`)
        
      } catch (err) {
        console.log(err);        
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [domain]);
  
  useEffect(() => {
    const fetchData = async () => {      
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}api/dashboard/component?link=/activity/${link}`);        
        setData(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [link]);

  // Conditional rendering
  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const overlayStyle = {
    position: 'absolute',           // Absolutely position the overlay on top of the background
    top: '150px',
    left: 0,
    right: 0,
    bottom: '150px',
    backgroundImage: `url(${appLogo})`,  // Dynamically use the appLogo as the background image
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    opacity: 0.1,                   // Set opacity for transparency (0 is fully transparent, 1 is opaque)
    pointerEvents: 'none',   
  };

  return (
    <div>
      <div style={overlayStyle}></div>

      {data && data.map((comp, index) => (
        <DynamicComponent key={index} component={comp} />
      ))}
    </div>
  );
};

export default Activity;